export const SEPOLIA_BASE_URL = 'https://sepolia.api.avnu.fi';
export const BASE_URL = 'https://starknet.api.avnu.fi';
